import { useNavigate } from "react-router-dom";
import { useEffect } from "react";
import { usePageMeta } from "../../../hooks/usePageMeta";
import { Layout } from "../../layout/Layout";
import { PPSection } from "./PPSection";
import { ppSections, ppIntro } from "./privacy.data";

export function PrivacyPolicy() {
  const navigate = useNavigate();

  usePageMeta({
    title: "Privacy Policy | 360PLUS",
    description: "Read the Privacy Policy describing how 360 Plus LLC collects, stores, and uses your personal information.",
    canonical: "https://360plusapp.com/privacy-policy",
    noindex: true,
  });

  useEffect(() => {
    document.body.className = "legal-page";
    return () => { document.body.className = ""; };
  }, []);

  return (
    <section className="section section-masthead section-fullheight text-left bg-dark-1" data-arts-theme-text="light">
      <div className="section-masthead__inner section-fullheight__inner container-fluid">
        <div className="main-container">
        <Layout>
          <div className="legal-selector-container">
            <div
              className="legal-selector"
              onClick={() => navigate("/terms-of-service")}
              role="button"
              tabIndex={0}
            >
              Terms of Use
            </div>
            <div
              className="legal-selector selected"
              onClick={() => navigate("/privacy-policy")}
              role="button"
              tabIndex={0}
            >
              Privacy Policy
            </div>
          </div>

          <div className="legal-title-container">
            <div className="legal-title">Privacy Policy Notice</div>
            <div className="legal-date">Last updated: May 5, 2021</div>
          </div>

          <div
            className="legal-paragraph"
            dangerouslySetInnerHTML={{ __html: ppIntro }}
          />

          <div className="legal-table-of-contents">
            <div className="table-of-contents-title">Table of Contents</div>
            <ol className="table-of-contents-items">
              {ppSections.map((s) => (
                <li key={s.number} className="table-of-contents-item">
                  <a>{s.title}</a>
                </li>
              ))}
            </ol>
          </div>

          {ppSections.map((section) => (
            <PPSection key={section.number} section={section} />
          ))}
        </Layout>
        </div>
      </div>
    </section>
  );
}
